import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class CtaV5 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    return (
      <section className="cta-eight text-center  go-top">
        <div className="cta-eight__content">
          <h3>
            Free Demo & Easy Scheduling <br />
            For Experience Business Insights
          </h3>
          <p>
            Schedule a free demo to gain valuable insights into your business.
            <br /> Our experts will help you understand your strengths, identify
            areas for improvement, and achieve success.
          </p>
        </div>
        {/* /.cta-eight__content */}
        <img
          // src={publicUrl + "assets/images/resources/home-4-moc-3.png"}
          src="https://solverwp.com/demo/react/bizkar/assets/images/resources/home-4-moc-3.png"
          alt={imagealt}
          className="img-fluid"
        />
      </section>
    );
  }
}

export default CtaV5;
